module.exports = __webpack_public_path__ + "static/Grupo322-c4adc28e84d5f2b4a832084598e7de36.png";